import { ApprovalStatus } from 'model/business-enums';
import { Country } from 'model/business-keywords';
import { PersonInfo } from 'model/business-types';
import { QueryParams } from 'model/essential-types';
import { EntityInfo, EnumInfo } from 'model/platform-types';

export abstract class TravelRequestsListApi {
  abstract queryTravelRequests(type: TravelRequestsQueryType, filter: TravelRequestsQueryFilter, params: QueryParams): Promise<TravelRequestsQueryRecord[]>;
}

export enum TravelRequestsQueryType {
  Current = 1,
  Past = 2,
  ForReview = 3,
  Reviewed = 4,
  All = 5
}

export interface TravelRequestsQueryFilter {
  text: string | null;
  from: string | null;
  to: string | null;
  statusValue: ApprovalStatus | null;
  includeArchived: boolean;
}

export interface TravelRequestsQueryRecord extends EntityInfo {
  from: string | null;
  to: string | null;
  travelers: PersonInfo[];
  countries: CountryStatus[];
  status: EnumInfo<ApprovalStatus>;
  statusDate?: string;
  isActive: boolean;
}

export interface CountryStatus {
  country: Country;
  status: EnumInfo<ApprovalStatus> | null;
}
